export const advertiserOffers = [
  {
    id: 1,
    icon: 'ri-trophy-line',
    titleKey: 'advertisers.offer1',
    descKey: 'advertisers.offer1Desc',
  },
  {
    id: 2,
    icon: 'ri-computer-line',
    titleKey: 'advertisers.offer2',
    descKey: 'advertisers.offer2Desc',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    titleKey: 'advertisers.offer3',
    descKey: 'advertisers.offer3Desc',
  },
  {
    id: 4,
    icon: 'ri-flag-line',
    titleKey: 'advertisers.offer4',
    descKey: 'advertisers.offer4Desc',
  },
  {
    id: 5,
    icon: 'ri-shirt-line',
    titleKey: 'advertisers.offer5',
    descKey: 'advertisers.offer5Desc',
  },
  {
    id: 6,
    icon: 'ri-mail-send-line',
    titleKey: 'advertisers.offer6',
    descKey: 'advertisers.offer6Desc',
  },
];

export const audienceItems = [
  'advertisers.audience1',
  'advertisers.audience2',
  'advertisers.audience3',
  'advertisers.audience4',
];